import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-chall-app-form',
  templateUrl: './payment-chall-app-form.component.html',
  styleUrls: ['./payment-chall-app-form.component.css']
})
export class PaymentChallAppFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/payment-chall-approval/payment-chall-app-form/payment-chall-app-form.component.ts